import { useQuery } from '@tanstack/react-query';
import { throwUnlessDefined } from 'utils/functional/functionalUtils.ts';
import {gothenburgApiAuthHeaders} from 'appUtils/authentication/authenticationUtils.ts';


const REACT_APP_DETECTOR_API_URL = throwUnlessDefined(process.env.REACT_APP_DETECTOR_BASE_API_URL);
const detectorApiUrl  =  `${REACT_APP_DETECTOR_API_URL}tram-tag-resend`;
const fetchTagTramData = async (): Promise<any> => {

  const response = await fetch(
    detectorApiUrl,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        ...gothenburgApiAuthHeaders(),
      },
    },
  );

  if (response.status === 500) {
    throw new Error("500")
  }

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
};

const useFetchAllTagsAndTram = () => {
  const { isLoading, error, data} = useQuery({
    queryKey: ['fetchTagTramData'],
    queryFn: () => fetchTagTramData(),
    retry: (failureCount, error) => {
        if(error){
          return failureCount < 4;
        }
        return false;
    },
    retryDelay: 2000,
  });

  return {
    data,
    isLoading,
    error,
  };
};

export default useFetchAllTagsAndTram;
